<!-- Popup shell. Set [inline]="true" to render the same form in a page,
     as the facilities Overview tab does. -->
<ng-template #facilityForm>
        <div class="p-3 mx-auto" style="max-width: 800px;">
            <dx-form id="form" [(formData)]="formData" [readOnly]="false" labelLocation="top"
                [showColonAfterLabel]="false" [showValidationSummary]="true" validationGroup="editFacilityData"
                [colCount]="isMobile ? 1 : 2">

                <dxi-item itemType="group" caption="Facility Information" [colSpan]="2" [colCount]="isMobile ? 1 : 2">
                    <dxi-item dataField="name" [editorOptions]="{ stylingMode: 'outlined' }">
                        <dxo-label text="Facility Name"></dxo-label>
                        <dxi-validation-rule type="required" message="Facility name is required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="phone" [editorOptions]="{
                        stylingMode: 'outlined',
                        mask: '(000) 000-0000',
                        useMaskedValue: true,
                        maskInvalidMessage: 'The phone must have a correct USA phone format',
                        inputAttr: { 'data-testid': 'edit-facility-input-phone' }
                    }">
                        <dxo-label text="Facility Phone"></dxo-label>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" caption="Delivery Address" [colSpan]="2" [colCount]="isMobile ? 1 : 3">
                    <dxi-item dataField="delivery_address.line_1" [colSpan]="isMobile ? 1 : 3" [editorOptions]="{ stylingMode: 'outlined', onValueChanged: onAddressFieldChange }">
                        <dxo-label text="Address"></dxo-label>
                        <dxi-validation-rule type="required" message="Address line is required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="delivery_address.line_2" [colSpan]="isMobile ? 1 : 3" [editorOptions]="{ stylingMode: 'outlined', onValueChanged: onAddressFieldChange }">
                        <dxo-label text="Address line 2"></dxo-label>
                    </dxi-item>
                    <dxi-item dataField="delivery_address.city" [editorOptions]="{ stylingMode: 'outlined', onValueChanged: onAddressFieldChange }">
                        <dxo-label text="City"></dxo-label>
                        <dxi-validation-rule type="required" message="City is required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="delivery_address.state" [editorOptions]="{ stylingMode: 'outlined', disabled: true }">
                        <dxo-label text="State"></dxo-label>
                        <dxi-validation-rule type="required" message="State is required"></dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="delivery_address.postal_code" [editorOptions]="{ stylingMode: 'outlined', onValueChanged: onAddressFieldChange }">
                        <dxo-label text="Postal Code"></dxo-label>
                        <dxi-validation-rule type="required" message="Postal code is required"></dxi-validation-rule>
                    </dxi-item>
                </dxi-item>
            </dx-form>

            <!-- Address verification: suggestion + not-found panels handled inside -->
            <app-address-verification
                #av
                *ngIf="formData?.delivery_address"
                [address]="formData.delivery_address"
                [(verify)]="triggerVerify"
                (onResult)="onVerificationResult($event)"
                class="mt-2">
            </app-address-verification>

            <div class="d-flex justify-content-end align-items-center mt-4">
                <dx-button text="Cancel" type="normal" (onClick)="closeModal()" class="mr-2"></dx-button>
                <dx-button
                    id="save-facility-btn"
                    [text]="av?.verifying ? 'Verifying...' : 'Save'"
                    type="default"
                    [disabled]="triggerVerify || av?.active"
                    (onClick)="saveChanges()">
                </dx-button>
            </div>
            <p class="text-muted mt-3">
                <i class="dx-icon-info mr-1"></i>
                Note: To change the state, you must create a new facility instead.<br>
                Address changes are not permitted if the facility has active orders (placed, processing, etc).
            </p>
        </div>
</ng-template>

<dx-popup *ngIf="!inline" class="popup" [showTitle]="true" title="Edit Facility Details" [fullScreen]="isMobile"
    [showCloseButton]="true" [(visible)]="visible" (onHiding)="closeModal()"
    [width]="isMobile ? '100vw' : 800" [height]="isMobile ? '100vh' : '90vh'"
    [maxHeight]="isMobile ? '100vh' : '90vh'"
    [elementAttr]="{ 'data-testid': 'edit-facility-modal' }">
    <dx-scroll-view width="100%" height="100%">
        <ng-container *ngTemplateOutlet="facilityForm"></ng-container>
    </dx-scroll-view>
</dx-popup>

<ng-container *ngIf="inline" [ngTemplateOutlet]="facilityForm"></ng-container>